module.exports = __webpack_public_path__ + "img/1574339568.3fa84844.jpg";